export default "__VITE_ASSET__DgyiU0kc__"